export class FrontendConfig {

  public static readonly TABLE_FILTER_DEBOUNCE_TIME = 300;

  public static readonly TABLE_PAGE_SIZE = 10;
  public static readonly TABLE_PAGE_SIZE_OPTIONS = [5, 10, 25, 100];

}
